<template>
  <div>
    <!-- 移动端组件：仅在移动端（isMobile 为 true）时渲染，避免 PC 端加载占用内存 -->
    <div v-if="isMobile">
      <MobileNavBar class="hidden-md-and-up" />
      <MobileCarouselHome class="hidden-md-and-up" />
      <MainTopMobile class="hidden-md-and-up" />
      <MobileProShow class="hidden-md-and-up" />
      <UserCasesMobile class="hidden-md-and-up" />
      <NewsInformationMobile class="hidden-md-and-up" />
      <PartnersMobile class="hidden-md-and-up" />
      <MobileCallme class="hidden-md-and-up" />
    </div>

    <div class="pc-wrapper" v-if="!isBaiduMobile">
      <PCNavbar class="hidden-xs-only none_992" />
      <CarouselHome class="hidden-xs-only none_992" />
      <MainTop class="hidden-xs-only none_992" />
      <ProShow class="hidden-xs-only none_992" />
      <UserCases class="hidden-xs-only none_992" />
      <NewsInformation class="hidden-xs-only none_992" />
      <Partners class="hidden-xs-only none_992" />
      <!-- ...existing code... -->
      <CallMe class="hidden-xs-only none_992" />
    </div>
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CarouselHome from "@/components/carousel_home/index";
import MobileCarouselHome from "@/components/carousel_home/mobileIndex.vue";
import TodoShow from "@/components/todo_show/index";
import MainTop from "@/components/main_top/index";
import UserCasesMobile from "@/components/user_cases_mobile/index";
import MainTopMobile from "@/components/main_top_mobile/index";
import ProShow from "@/components/pro_show/index";
import MobileProShow from "@/components/pro_show/MobileProShow.vue";
import UserCases from "@/components/user_cases/index";
import NewsInformation from "@/components/news_information/index";
import NewsInformationMobile from "@/components/news_information_mobile/index";
import Partners from "@/components/partners/index";
import PartnersMobile from "@/components/partnersMobile/index";
import NewsInfomation from "@/components/news_infomation/index";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/callMeMile.vue";
import { visitStatistics } from "@/api/statistics";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    MobileCarouselHome,
    TodoShow,
    NewsInfomation,
    NewsInformationMobile,
    CallMe,
    MainTop,
    MainTopMobile,
    ProShow,
    MobileProShow,
    UserCases,
    UserCasesMobile,
    NewsInformation,
    Partners,
    PartnersMobile,
    MobileCallme,
  },
  data() {
    return {
      isBaiduMobile: false,
      isMobile: false, // 新增：控制是否渲染移动端组件
    };
  },
  mounted() {
    // 检测是否为百度移动端内核（兼容 baidubox / baidubrowser / bdbrowser 等 UA）
    try {
      const ua = navigator.userAgent || "";
      const isMobileUa = /Android|iPhone|iPad|Mobile/i.test(ua);
      const isBaiduUa = /(baidubox|baidubrowser|bdbrowser|baidu)/i.test(ua);
      this.isBaiduMobile = Boolean(isMobileUa && isBaiduUa);
    } catch (e) {
      this.isBaiduMobile = false;
    }
    this.updatePcScale();
    window.addEventListener("resize", this.updatePcScale);
    // 调用访问统计接口
    // 判断用户来源
    const referrer = document.referrer;
    console.log("用户来源:", referrer);

    // if (referrer.includes("chnsoft.com.cn") || referrer.includes("236")) {
    //   console.log("来自chnsoft搜索");
    // } else {
    //     this.getVisitStatistics();
    // }

    // 常见判断：是否来自搜索引擎
    if (referrer.includes("link")) {
      // 来自搜索流量
      this.getVisitStatistics();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updatePcScale);
  },
  methods: {
    // 访问统计
    getVisitStatistics() {
      visitStatistics()
        .then((res) => {
          console.log("访问统计接口调用成功", res);
        })
        .catch((err) => {
          console.error("访问统计接口调用失败", err);
        });
    },
    updatePcScale() {
      const designWidth = 1200; // 根据设计稿改这里
      const w = window.innerWidth || document.documentElement.clientWidth;
      const scale = Math.min(1, w / designWidth);
      // 写入全局 CSS 变量，transform 读取此变量（无单位，适合 scale()）
      document.documentElement.style.setProperty("--pc-scale", String(scale));

      // 根据宽度判断是否为移动端，避免在 PC 端渲染移动组件
      this.isMobile = w <= 992;
    },
  },
};
</script>

<style lang="scss">
/* 保持页面不横向滚动（取消 scoped，需全局生效） */
body,
html {
  overflow-x: hidden;
}

/* PC 容器：按设计宽度等比缩放（使用 JS 计算的 --pc-scale，避免 clamp 单位不匹配报错） */
.pc-wrapper {
  width: 100%; /* 设计稿宽度，按实际项目修改 */
  margin: 0 auto;
  transform-origin: top center;
  // transform: scale(var(--pc-scale, 1));
  height: auto;
  display: block;
}

/* 通用响应：图片 / 媒体自适应容器宽度 */
.pc-wrapper img,
.pc-wrapper video,
.pc-wrapper iframe {
  max-width: 100%;
  height: auto;
  display: block;
}

/* bottom_circle 调整为响应式（PC 下生效） */
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),
    url(../assets/img/smalldot1.png);
  background-position: 0 0, 110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;

  h1 {
    font-size: clamp(18px, 2.5vw, 40px);
    padding-bottom: 20px;
  }

  .circle_img {
    width: 100%;
    img {
      width: 70%;
      max-width: 800px;
      height: auto;
    }
  }
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 在小屏下隐藏带 none_992 的 PC 专用元素（保持现有行为） */
@media (max-width: 992px) {
  .none_992 {
    display: none !important;
  }
  /* 移动端不需要缩放 pc-wrapper，改为宽度100%以避免奇怪表现 */
  .pc-wrapper {
    width: 100%;
    transform: none !important;
    margin: 0;
    padding: 0;
  }
}

/* 备用：若仍有渲染漏出，可通过 body 类强制隐藏 PC 专属元素 */
.is-baidu .none_992 {
  display: none !important;
}
</style>
